// extracted by mini-css-extract-plugin
module.exports = {"backButton":"Breadcrumb_backButton__mqWLN"};